<template>
  <el-dialog
    v-model="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    :width="dialogWidth"
    @close="handleClose"
  >
    <template #header>
      <div class="dialog-header">
        <span> مدیریت اثر انگشت </span>
      </div>
    </template>
    <div style="text-align: right">
      <b>وضعیت اثر انگشت:</b>
      <span style="color: green" v-if="activeDevice.user_local_id != null">
        ثبت شده
      </span>

      <span style="color: red" v-else> ثبت نشده</span>
    </div>

    <div class="result-message" v-html="resultMessage"></div>
    <el-progress
      v-if="step == 1"
      type="circle"
      :percentage="percentage"
      :stroke-width="8"
      :show-text="false"
      stroke-color="#084808"
      width="35"
    />
    <template #footer>
      <el-button @click="handleCancel" :disabled="waiting">بستن</el-button>
      <el-button
        type="primary"
        :loading="waiting"
        @click="handleConfirm"
        :disabled="waiting"
        v-if="activeDevice.user_local_id == null"
        >درخواست</el-button
      >
    </template>
  </el-dialog>
</template>

<script setup>
import {
  ref,
  watch,
  defineEmits,
  defineProps,
  onMounted,
  onBeforeUnmount,
} from "vue";

import socket from "@/services/socket";

const props = defineProps({
  modelValue: Boolean,
  activeDevice: Array,
});
const emit = defineEmits(["update:modelValue", "confirmed"]);

const visible = ref(props.modelValue);
const waiting = ref(false);
const step = ref(false);
const resultMessage = ref(null);
let timeout = null;
const dialogWidth = ref("400px");
const updateDialogWidth = () => {
  dialogWidth.value = window.innerWidth <= 600 ? "98%" : "400px";
};
onMounted(() => {
  updateDialogWidth();
  window.addEventListener("resize", updateDialogWidth);
});

watch(
  () => props.modelValue,
  (val) => {
    visible.value = val;
  }
);
watch(visible, (val) => {
  emit("update:modelValue", val);
  resultMessage.value = null;
});
const percentage = ref(0);
let intervalId = null;

function startProgress() {
  step.value = true;
  const duration = 40000; // 60 ثانیه
  const updateInterval = 100; // بروزرسانی هر 100 میلی‌ثانیه
  const totalSteps = duration / updateInterval;
  const stepIncrement = 100 / totalSteps;

  intervalId = setInterval(() => {
    percentage.value += stepIncrement;
    if (percentage.value >= 100) {
      percentage.value = 100;
      clearInterval(intervalId);
    }
  }, updateInterval);
}
function clearProgress() {
  step.value = false;
  percentage.value = 0;
  if (intervalId) clearInterval(intervalId);
}
onBeforeUnmount(() => {
  clearProgress();
});

const handleClose = () => {
  if (!waiting.value) visible.value = false;
};

const handleCancel = () => {
  if (!waiting.value) visible.value = false;
};

const handleConfirm = () => {
  clearProgress();
  waiting.value = true;
  resultMessage.value = "";

  socket.emit("fingerprint/add_request", {
    deviceID: props.activeDevice.device_id,
    pin: props.activeDevice.pin,
  });

  timeout = setTimeout(() => {
    clearProgress();
    resultMessage.value =
      '<p style="color:red">متاسفانه پاسخی از سمت دستگاه دریافت نشد.</p>';
    waiting.value = false;
  }, 60000);

  socket.once("fingerprint/request_response", (data) => {
    if (data.status == 1) {
      // <span class="spinner"></span>
      resultMessage.value = `${data.message}`;
      startProgress();
      return;
    }
  });
  socket.once("fingerprint/status", (data) => {
    clearProgress();
    if (data.status != 1) {
      step.value = false;
      resultMessage.value = `<p style="color:red">${data.message}</p>`;
      waiting.value = false;
      return;
    }
    waiting.value = false;
    visible.value = false;

    emit("confirmed", data); // <=== این خط اضافه کن
  });
};
</script>

<style scoped>
.dialog-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: bold;
}
::v-deep(.el-dialog__body) {
  text-align: right !important;
}
::v-deep(.el-dialog__footer) {
  text-align: center !important;
}

.el-dialog__footer button {
  margin: 5px;
  width: 100px;
}
.result-message {
  text-align: right;
  margin-top: 12px;
  color: #084808;
  font-weight: 600;
}
/*::v-deep(.spinner) {
  display: block;
  margin: 0 auto; /* فاصله از متن */
/*width: 20px; /* اندازه عرض */
/* height: 20px; /* اندازه ارتفاع */
/* border: 5px solid #f3f3f3; /* رنگ پس‌زمینه‌ی دایره */
/* border-top: 5px solid #023602; /* رنگ قرمز برای قسمت چرخان */
/* border-radius: 50%; /* دایره‌ای شدن */
/* animation: spin 1s linear infinite; /* چرخش بی‌نهایت */
/*}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}*/
::v-deep(.progress-ring) {
  margin: 0 auto;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: conic-gradient(#f44336 0% 0%, #f3f3f3 0% 100%);
  animation: fillRingSteps 4s steps(4) infinite;
}
@keyframes fillRingSteps {
  0% {
    background: conic-gradient(#f44336 0% 0%, #f3f3f3 0% 100%);
  }
  100% {
    background: conic-gradient(#f44336 0% 100%, #f3f3f3 0% 0%);
  }
}
</style>
